// Tek geçiş adımı: veri değişikliği açıklaması, son rapor / uygulama çıktısı ve "Uygula" düğmesi
import { useState } from 'react';
import { CheckCircle2, AlertTriangle, Circle, Loader2, ChevronDown } from 'lucide-react';
import { Button } from '../ui/button';

const time = (iso) => (iso ? new Date(iso).toLocaleString('tr-TR') : '');

const Badge = ({ step, running }) => {
  if (running) return <span className="flex items-center gap-1 text-xs font-medium text-sky-700"><Loader2 className="h-3.5 w-3.5 animate-spin" />Çalışıyor</span>;
  if (step.applied) return <span className="flex items-center gap-1 text-xs font-medium text-emerald-700"><CheckCircle2 className="h-3.5 w-3.5" />Uygulandı</span>;
  if (step.blocked || (step.report && !step.report.ok)) return <span className="flex items-center gap-1 text-xs font-medium text-rose-700"><AlertTriangle className="h-3.5 w-3.5" />Engel</span>;
  if (step.report) return <span className="flex items-center gap-1 text-xs font-medium text-slate-700"><Circle className="h-3.5 w-3.5" />Rapor uygun</span>;
  return <span className="text-xs text-slate-400">Rapor yok</span>;
};

export const MigrationStepRow = ({ step, index, running, canApply, onApply }) => {
  const [open, setOpen] = useState(false);
  const out = step.apply && !step.applied ? step.apply : step.report;
  return (
    <div className="py-4" data-testid={`mig-step-${step.key}`}>
      <div className="flex flex-wrap items-start gap-3">
        <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-slate-100 text-xs font-bold text-slate-600">{index + 1}</span>
        <div className="min-w-[220px] flex-1">
          <div className="flex flex-wrap items-center gap-3"><p className="font-medium text-slate-900">{step.title}</p><span data-testid={`mig-step-state-${step.key}`}><Badge step={step} running={running} /></span></div>
          <p className="mt-1 text-xs text-slate-600" data-testid={`mig-step-changes-${step.key}`}>{step.changes}</p>
          {out && <button type="button" onClick={() => setOpen(o => !o)} className="mt-1 flex items-center gap-1 text-xs text-sky-700 hover:underline" data-testid={`mig-step-toggle-${step.key}`}>
            <ChevronDown className={`h-3 w-3 transition-transform ${open ? 'rotate-180' : ''}`} />{step.apply && !step.applied ? 'Uygulama çıktısı' : 'Rapor çıktısı'} · {time(out.at)} · çıkış kodu {out.exit_code}
          </button>}
        </div>
        {!step.applied && <Button size="sm" disabled={!canApply} onClick={onApply} data-testid={`mig-step-apply-${step.key}`}>Uygula</Button>}
      </div>
      {open && out && <pre className="mt-2 max-h-72 overflow-auto rounded-lg bg-slate-950 p-3 text-[11px] leading-relaxed text-slate-100" data-testid={`mig-step-output-${step.key}`}>{out.output}</pre>}
    </div>
  );
};
